<template lang='pug'>
.parcel-slide-out(:class='{ "has-parcel" : asset !== null }')
	side-sheet(
		:state='state'
		@close='$emit( "close" )'
		@edit='$emit( "edit" )'
		@delete='$emit( "delete" )'
	)

		.title-container(
			v-if='asset'
			slot='title'
		)
			h1.title Developer/Utility Parcel Reference

		page.facilities-page.side-sheet-content(
			slot='side-sheet-content'
		)

			.body-wrapper(slot='main-body')
				parcel(
					v-if='asset'
					:parcel='asset'
				)

				.loading-indicator.spacey(v-else) Loading
					span .
					span .
					span .
</template>

<script>
import Parcel from '@/components/slide-outs/parcels/Parcel';
import SideSheet from '@/components/SideSheet';
import Page from '@/components/Page';

import { objectOrNull } from '@/lib/vue-validators';


export default {
	name : 'parcel-slide-out',

	props : {
		state : {
			type     : String,
			required : true,
		},

		asset : {
			required  : true,
			validator : objectOrNull,
		},

		assetKey : {
			required : true,
		}
	},

	components : {
		Parcel,
		SideSheet,
		Page,
	}
};
</script>

<style lang='scss'>
.parcel-slide-out {

	&:not(.has-parcel) {

		.toggle,
		.main {
			opacity: 0;
		}
	}

	.body-wrapper {
		width: 100%;

		.loading-indicator {
			text-align: center;
		}
	}

	.body {

		> p.spacey {
			text-align: center;
		}
	}
}
</style>
